import { render, staticRenderFns } from "./correctInventories.vue?vue&type=template&id=21991d4a&scoped=true&"
import script from "./correctInventories.vue?vue&type=script&lang=js&"
export * from "./correctInventories.vue?vue&type=script&lang=js&"
import style0 from "./correctInventories.vue?vue&type=style&index=0&id=21991d4a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21991d4a",
  null
  
)

component.options.__file = "correctInventories.vue"
export default component.exports